import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("bey-cookie-consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = (value: string) => {
    localStorage.setItem("bey-cookie-consent", value);
    setIsClosing(true);
    setTimeout(() => setVisible(false), 400);
  };

  if (!visible) return null;

  return (
    <AnimatePresence>
      {!isClosing && (
        <motion.div
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "100%", opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6"
        >
          <div className="max-w-2xl mx-auto bg-dark-300/95 backdrop-blur-md border border-gold/20 rounded-2xl p-6 shadow-2xl shadow-black/50">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-cookie-line text-gold text-2xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="font-playfair text-white text-lg font-semibold mb-2">
                  Çerez Politikası
                </h3>
                <p className="text-white/60 text-sm font-montserrat leading-relaxed">
                  Size daha iyi bir deneyim sunabilmek için çerezler kullanıyoruz. Devam ederek{" "}
                  <Link to="/cerez-politikasi" className="text-gold hover:underline cursor-pointer">
                    Çerez Politikamızı
                  </Link>{" "}
                  kabul etmiş sayılırsınız.
                </p>
              </div>
            </div>
            <div className="flex items-center justify-end gap-3 mt-5">
              <button
                onClick={() => handleClose("rejected")}
                className="px-5 py-2.5 border border-white/20 text-white/60 hover:text-white hover:border-white/40 text-sm font-semibold font-montserrat rounded-full transition-smooth cursor-pointer whitespace-nowrap"
              >
                Reddet
              </button>
              <button
                onClick={() => handleClose("accepted")}
                className="px-5 py-2.5 gold-gradient text-black text-sm font-semibold font-montserrat rounded-full gold-glow cursor-pointer whitespace-nowrap"
              >
                Kabul Et
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
